import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component ArrowRestoreIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <ArrowRestoreIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <ArrowRestoreIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const ArrowRestoreIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      data-testid="ArrowRestoreIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="evenodd"
        d="M17.026 19.796a9 9 0 0 1-12.294-3.294l-1.732 1 .653-4.87 4.543 1.87-1.732 1a7 7 0 1 0 2.562-9.563 6.94 6.94 0 0 0-3.248 4.254l-1.94-.52a8.9 8.9 0 0 1 4.188-5.466 9 9 0 0 1 9 15.589"
        clipRule="evenodd"
      />
    </svg>
  )
);
ArrowRestoreIcon.displayName = "ArrowRestoreIcon";
export default ArrowRestoreIcon;
